export enum DriverDefaults {
  NO_DRIVER_IN_VEHICLE = 'No driver in the vehicle',
  DRIVER_NOT_ON_POLICY = 'Driver is not on the policy',
  VEHICLE_NOT_ON_POLICY = 'Vehicle is not on policy',
}

export interface Driver {
  id?: string;
  firstName: string;
  lastName: string;
}
